<template>
  <div
    class="FormGroup"
    :class="{ 'FormGroup--large': large }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="FormGroup-header">
      <slot name="header">
        <h3 v-if="title" v-text="title"></h3>
        <!-- @slot Description du groupe de champs -->
        <slot name="description"></slot>
      </slot>
    </div>
    <div class="FormGroup-main">
      <!-- @slot Éléments du formulaire -->
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.FormGroup {
  display: flex;
  flex-direction: row;

  &.FormGroup--large {
    flex-direction: column;
  }

  &-header {
    @extend .pr-5;
    width: 300px;

    &.FormGroup--large & {
      flex-basis: 66.667%;
    }

    h2 {
      text-transform: uppercase;
      font-size: $font-size-base-alt;
      font-weight: $font-weight-bolder;
    }
  }
  &-main {
    flex: 1;
  }

  @include media-breakpoint-down(md) {
    flex-direction: column;

    &-header {
      padding-bottom: map-get($spacers, 4); // .pb-4
      margin-bottom: map-get($spacers, 4); // .mb-4
      border-bottom: 1px solid $gray-200;
      width: 100%;
    }
  }
  @include media-breakpoint-down(sm) {
    flex-direction: column;

    &-header {
      padding-bottom: map-get($spacers, 3); // .pb-2
      margin-bottom: map-get($spacers, 3); // .mb-3
      padding-right: 0 !important;
      border-bottom: 1px solid $gray-200;
    }
  }
}
</style>

<script>
/**
 * Groupe de champs avec description.
 */
export default {
  name: 'UbiFormGroup',
  props: {
    /**
     * Titre du groupe de champs.
     */
    title: String,
    /**
     * Force le groupe de champs à être sur toute la largeur disponible.
     */
    large: { type: Boolean, default: false }
  }
}
</script>

<docs>
### Exemple

```jsx
<ubi-form-group title="Titre du groupe">
  <span slot="description">Description détaillée</span>
  <div>Champs du formulaire</div>
</ubi-form-group>
```
</docs>
